module.exports = "<article class=article :class=\"{'article-legal':art}\"> <div class=article-expand v-if=art @click=\"show=!show\">&rarr;</div> <div class=article-text> <textarea-growing :model.sync=article.text @keydown.enter=enter @focus=\"show=true\" @blur=\"show=false\"></textarea-growing> </div> <div class=article-tools> <span class=\"ref-icon icon-times\" @click=rm>&times;</span> </div> <p v-if=show&&art v-text=\"art['dcterms:description']\" class=item-lookup-text></p> <p v-if=show&&!art class=item-lookup-failed>Het artikel is niet gelinkt omdat het niet gevonden werd.</p> </article>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LbLegal.vue
 ** module id = 142
 ** module chunks = 0
 **/